import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import GeneralApiLoading from "../general/GeneralApiLoading";
import download from "downloadjs";
import ReactLoading from "react-loading";
import * as theme from "../theme";

import {
  changeDoNotShowNavigationButtons,
  getCurrentFileContent,
  getDataForInsurerView,
  getDataForInsurerViewData,
  getPDFV2fromURL,
  getPDFstatus,
  getPDFV2status,
} from "../store/components";
import { getIRS } from "../store/quotes";

const InsurerView = () => {
  const { search } = useLocation();
  const dispatch = useDispatch();
  const pdfstatus = useSelector(getPDFV2status);
  const irs = useSelector(getIRS);

  const encryptedProspectId = search.substring(4);

  useEffect(() => {
    dispatch(
      getPDFV2fromURL({
        id: encryptedProspectId,
      })
    );
  }, [dispatch, encryptedProspectId]);

  return (
    <GeneralApiLoading
      possibleApiValue={pdfstatus}
      loadingComponent={<LoadingDotsOrange></LoadingDotsOrange>}
    >
      {pdfstatus}

      <ShowBlob blob={pdfstatus}></ShowBlob>
      {/* <DownloadBlob blob={pdfstatus} filecontent={filecontent}></DownloadBlob> */}
    </GeneralApiLoading>
  );
};

const ShowBlob = ({ blob }) => {
  useEffect(() => {
    window.location.href = blob;
  }, []);

  return <div>Successfully downloaded</div>;
};

const LoadingDotsOrange = () => {
  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        fontSize: 30,
        fontFamily: "GibsonSemiBd",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <div>
        {" "}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <ReactLoading
            type={"bubbles"}
            color={theme.COLORS.secondary_orange}
          />
        </div>
        <div>Generating PDF....</div>
      </div>
    </div>
  );
};

export default InsurerView;
